import { SegmentState, REQUEST_SEGMENTS } from "./types";

const initialState: SegmentState = {
  segments: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_SEGMENTS:
      return action.payload;
    default:
      return state;
  }
}
